import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

export default function AdminRestockWaitlist() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    apiClient.get("/admin/restock-waitlist").then((res) => setRows(res.data)).finally(() => setLoaded(true));
  }, []);

  const totalWaiting = rows.reduce((s, r) => s + r.waiting, 0);

  return (
    <div data-testid="admin-restock-waitlist-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">Restock Waitlist</h1>
        <span className="text-sm text-slate-500" data-testid="restock-waitlist-total">{totalWaiting} researcher{totalWaiting === 1 ? "" : "s"} waiting</span>
      </div>

      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-3">Product</th>
              <th className="px-4 py-3">Waiting</th>
              <th className="px-4 py-3">Current Stock</th>
              <th className="px-4 py-3">Latest Signup</th>
              <th className="px-4 py-3">Emails</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.product_id} className="border-t border-slate-100 align-top" data-testid={`restock-waitlist-row-${r.slug || r.product_id}`}>
                <td className="px-4 py-3 font-medium text-slate-900">{r.product_name}</td>
                <td className="px-4 py-3"><span className="inline-flex items-center justify-center min-w-[28px] px-2 py-0.5 rounded-full bg-brandblue-600 text-white text-xs font-bold">{r.waiting}</span></td>
                <td className="px-4 py-3">
                  {r.stock_quantity == null ? "—" : r.stock_quantity === 0 ? <span className="text-red-600 font-semibold">Out of stock</span> : <span className="text-emerald-600 font-semibold">{r.stock_quantity} in stock</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap">{r.latest_signup ? new Date(r.latest_signup).toLocaleDateString() : "—"}</td>
                <td className="px-4 py-3 max-w-[320px]">
                  <span className="block text-xs text-slate-500 break-words">{r.emails.join(", ")}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {loaded && rows.length === 0 && (
          <p className="p-6 text-center text-slate-400 text-sm" data-testid="restock-waitlist-empty">
            No one is waiting on a restock right now. Signups appear here when researchers ask to be notified about sold-out products.
          </p>
        )}
      </div>
      <p className="text-xs text-slate-500 mt-3">Subscribers are emailed automatically when you restock a product from 0. Notified signups leave this list.</p>
    </div>
  );
}
